import { strokeStyle } from "../AppConst";
import { PinPath, Point } from "../Types";
import { resolveSegmentEndpoints } from "./pinPath";

export function clearCanvas(ctx: CanvasRenderingContext2D, width: number, height: number): void {
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);
}

export function drawPath(ctx: CanvasRenderingContext2D, path: PinPath, points: Point[]): void {
    if (path.pinIndices.length < 2 || points.length === 0) return;

    const segments = resolveSegmentEndpoints(points, path);
    ctx.strokeStyle = strokeStyle;
    for (const [from, to] of segments) {
        ctx.beginPath();
        ctx.moveTo(from[0], from[1]);
        ctx.lineTo(to[0], to[1]);
        ctx.stroke();
    }
}

export function drawPathWithClear(ctx: CanvasRenderingContext2D, path: PinPath, points: Point[], width: number, height: number): void {
    clearCanvas(ctx, width, height);
    drawPath(ctx, path, points);
}
